export class ApiError extends Error {
    constructor(statusCode, message, stack, translationKey) {
        super(message);
        this.statusCode = statusCode;
        this.stack = stack;
        this.translationKey = translationKey;
    }
}
//# sourceMappingURL=apiError.js.map